<template>
	<ListItem
		is-recipient
		info
		:message="message"
		:force-sender-display="true"
	>
		<template #text>
			<b>Wir bitten um die Zusendung eines Lebenslaufs.</b>
		</template>
	</ListItem>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";

export default {
	components: {
		ListItem
	},

	props: {
		message: {
			type: Object,
			required: true,
		}
	}
}
</script>
